import axios from 'axios';
import { AppConfig, JWT } from '../config';

const GetList = async (model, contentsType, lang) => {
	const data = {
		model : model,
		contentsType : contentsType,
		lang : lang
	}
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/guides', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
		console.warn('[GuideAction.GetList] non-success — empty fallback', { handler: 'GuideAction.GetList', target: model, reason: ret.data?.err || 'non-success' });
		return [];
	} catch (error) {
		console.warn('[GuideAction.GetList] failed — empty fallback', { handler: 'GuideAction.GetList', target: model, reason: error?.message || String(error) });
		return [];
	}
}

export const GuideAction = {
    GetList
};